import controller from '../../Shared/controller';
function eventsContainer() {
    async function fetchData() {
        try {
            const response = await fetch('/api/v1/eventsselection?CurrentPageId=' + pageId);

            if (!response.ok) {
                throw new Error('N�got gick fel med beg�ran');
            }
            const data = await response.json();
            populateEventsList(data);
            populateCategories(data);
            checkRadioButtonsFromURL(data);
            setDateFromURL(data);

            return data;
        } catch (error) {
            console.error('Ett fel uppstod vid h�mtning av data:', error);
        }
    }

    fetchData();


    const populateEventsList = (data) => {

        const eventsListContainer = document.getElementById('populateEventsList');
        let eventId = 0;
        const eventsArray = [];
        data.forEach(function (events) {
            let formattedDates = formatDateRangeWithTime(events.Dates);

            if (checkIfDateIsStillUpcoming(events.Dates)) {
                const eventsListToHtml = `

            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" id="event_${eventId}">
                <a href='${events.Url}'>
                    <div class="eventsblock normalize-height">
                        <h2 class="eventsblock__heading eventsblock__link">${events.Name}</h2>
                        <div class=eventsblock__image>
                        <img src="${events.ImageUrl}" alt="${events.ImageAltText}"/>
                        </div>
                        <div class="eventsblock__dates">
                            <p>${formatDateRange(events.Dates)}</p>
                        </div>
                        <div class="eventsblock__location">
                            ${events.Location ? `<p>${events.Location}</p>` : ''}
                        </div>
                        <div class="eventsblock__text">
                            ${events.Excerpt ? `<p>${events.Excerpt}</p>` : ''}
                        </div>
                    </div>
                </a>
            </div>
          `;

                eventsArray.push({ formattedDates, eventsListToHtml });
                eventId++;
            }
        });
        eventsArray.sort((a, b) => {
            const dateA = parseDateString(a.formattedDates);
            const dateB = parseDateString(b.formattedDates);
            //console.log("a = " + a + " , a.formattedDates = " + a.formattedDates + ", \n dateA = " + dateA)
            //console.log("b = " + b + " , b.formattedDates = " + b.formattedDates + ", \n dateB = " + dateB)
            return dateA - dateB;
        })
        eventsListContainer.innerHTML = eventsArray.map(item => item.eventsListToHtml).join('');
    }

    const checkIfDateIsStillUpcoming = (dates) => {
        const today = new Date();
        for (let i = 0; i < dates.length; i++) {
            const stopDate = new Date(dates[i].StopDate);
            if (stopDate >= today) {
                return true;
            }
        }
        return false;
    };

    const checkIfDateIsStillUpcomingfromSelected = (dates, selectedDate) => {
        for (let i = 0; i < dates.length; i++) {
            const stopDate = new Date(dates[i].StopDate);
            if (stopDate >= selectedDate) {
                return true;
            }
        }
        return false;
    };

    const formatDate = (date) => {
        const options = {
            day: "numeric",
            month: "short",
        };
        const dayAndMonth = date.toLocaleString("sv-SE", options);
        return dayAndMonth.replace(".", "");
    }
    const formatDateWithTime = (date) => {
        const options = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        };
        const dayAndMonthAndYear = date.toLocaleString("sv-SE", options);
        return dayAndMonthAndYear.replace(".", "");
    }

    const formatDateRangeWithTime = (dates) => {

        if (!Array.isArray(dates) || (dates == null || dates.length === 0)) {
            return "No dates provided.";
        }

        const currentDate = new Date();
        let nextStartDate = null;

        for (const date of dates) {
            const startDate = new Date(date.StartDate);
            if (startDate > currentDate) {
                nextStartDate = startDate;
                break;
            }
        }

        if (nextStartDate === null) {
            nextStartDate = new Date(dates[dates.length - 1].StartDate);
        }
        const lastDate = new Date(dates[dates.length - 1].StopDate);

        let formattedStartDate = formatDateWithTime(nextStartDate);
        let formattedStopDate = formatDateWithTime(lastDate);
        if (formattedStartDate == formattedStopDate) {
            let dateRangeString = `${formattedStartDate}`;
            return dateRangeString;
        } else {
            let dateRangeString = `${formattedStartDate} - ${formattedStopDate}`;
            return dateRangeString;
        }
        return dateRangeString;
    }

    const formatDateRange = (dates) => {

        if (!Array.isArray(dates) || (dates == null || dates.length === 0)) {
            return "No dates provided.";
        }

        const currentDate = new Date();
        let nextStartDate = null;

        for (const date of dates) {
            const startDate = new Date(date.StartDate);
            if (startDate > currentDate) {
                nextStartDate = startDate;
                break;
            }
        }

        if (nextStartDate === null) {
            nextStartDate = new Date(dates[dates.length - 1].StartDate);
        }
        const lastDate = new Date(dates[dates.length - 1].StopDate);

        let formattedStartDate = formatDate(nextStartDate);
        let formattedStopDate = formatDate(lastDate);
        if (formattedStartDate == formattedStopDate) {
            let dateRangeString = `${formattedStartDate}`;
            return dateRangeString;
        } else {
            let dateRangeString = `${formattedStartDate} - ${formattedStopDate}`;
            return dateRangeString;
        }

        return dateRangeString;
    }
    function parseDateString(dateString) {
        //console.log("Before extraction: " + dateString);
        const startDateString = dateString.split(' - ')[0];
        const parts = startDateString.split(' ');
        const day = parseInt(parts[0], 10);
        const month = getMonthNumber(parts[1]);
        const year = parseInt(parts[2], 10); 
        const timeString = parts.slice(3).join(' ');
        const [hours, minutes] = timeString.split(':');
        //console.log("parts: " + parts + " , day: " + day + " , month: " + month + " , year: " + year + " , timeString: " + timeString);
        return new Date(year, month - 1, day, hours, minutes);
    }
    function getMonthNumber(monthString) {
        const months = {
            jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, okt: 10, nov: 11, dec: 12,
            januari:1, februari: 2, mars: 3, april: 4, maj: 5, juni: 6, juli: 7, augusti: 8, september: 9, oktober: 10, november: 11, december: 12,
            january:1, february:2, june:6, july:7, august:8, october:10
        };

        return months[monthString.toLowerCase()];
    }
    const populateCategories = (data) => {
        const categoryList = document.getElementById('categoryList');

        if (!categoryList) {
            return;
        }

        categoryList.innerHTML = '';

        const showAllOption = document.createElement('li');
        showAllOption.innerHTML = `
        <label for="showAll" class='eventslist__filter--radio'>Visa alla
            <input type="radio" name="category" id="showAll" value="">
            <span class="radio-checkmark"></span>
        </label>
    `;
        categoryList.appendChild(showAllOption);

        const upcomingEvents = data.filter(event => checkIfDateIsStillUpcoming(event.Dates));

        // Collect unique category names from upcoming events
        const categoryNames = new Set();
        upcomingEvents.forEach(event => {
            event.Categories.forEach(category => {
                categoryNames.add(category.Name);
            });
        });

        categoryNames.forEach(categoryName => {
            const listItem = document.createElement('li');
            listItem.innerHTML = `
            <label for="${categoryName}" class='eventslist__filter--radio'>${categoryName}
                <input type="radio" name="category" id="${categoryName}" value="${categoryName}">
                <span class="radio-checkmark"></span>
            </label>
        `;
            categoryList.appendChild(listItem);
        });

        // Event listener for category selection
        categoryList.addEventListener('change', function (event) {
            if (event.target.type === 'radio' && event.target.name === 'category') {
                updateURL();
                updateEventsList(data);
            }
        });


        // Event listener for clear button
        const clearButton = document.getElementById('clearBtnEventsList');
        if (clearButton) {
            clearButton.addEventListener('click', function () {
                const filterDatePicker = document.getElementById('filterDateEventsList');

                const queryParams = new URLSearchParams(window.location.search);
                queryParams.delete('categories');
                queryParams.delete('date');
                const newURL = `${window.location.pathname}?${queryParams.toString()}`;
                window.history.replaceState({}, '', newURL);
                const showAllRadio = document.getElementById('showAll');
                if (showAllRadio) {
                    showAllRadio.checked = true;
                }

                const getCurrentDate = new Date().toISOString().split('T')[0];
                filterDatePicker.min = getCurrentDate;
                filterDatePicker.value = getCurrentDate;
                updateSpanValue(getCurrentDate);
                updateEventsList(data);
            });
        }


        // Event listener for date picker
        const filterDatePicker = document.getElementById('filterDateEventsList');
        if (filterDatePicker) {
            filterDatePicker.addEventListener('change', function (event) {
                updateURL();
                updateEventsList(data);
                updateSpanValue(event.target.value)
            });
        }

        const checkedRadio = document.querySelector('.eventslist__filter--categories input[type="radio"]:checked');
        if (!checkedRadio) {
            const showAllRadio = document.getElementById('showAll');
            if (showAllRadio) {
                showAllRadio.checked = true;
            }
        }
    
    };

    const updateURL = () => {
        const radios = document.querySelectorAll('.eventslist__filter--categories input[type="radio"]:checked');
        const selectedCategory = radios.length > 0 ? radios[0].value : '';

        const filterDatePicker = document.getElementById('filterDateEventsList');
        const selectedDate = filterDatePicker ? filterDatePicker.value : '';
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set('categories', selectedCategory);
        queryParams.set('date', selectedDate);
        const newURL = `${window.location.pathname}?${queryParams.toString()}`;

        window.history.replaceState({}, '', newURL);
    };

    const updateEventsList = (events) => {
        const radios = document.querySelectorAll('.eventslist__filter--categories input[type="radio"]:checked');
        const selectedCategory = radios.length > 0 ? radios[0].value : '';

        const selectedDate = new Date(document.getElementById('filterDateEventsList').value);

        const filteredEvents = events.filter(event => {
            const categoryMatch = selectedCategory === '' || event.Categories.some(category => category.Name === selectedCategory);
            const dateMatch = checkIfDateIsStillUpcomingfromSelected(event.Dates, selectedDate);

            return categoryMatch && dateMatch;
        });

        populateEventsList(filteredEvents);
    };

    const updateSpanValue = (date) => {
        const element = document.getElementById('srHiddenDate');
        if (date) {
            element.innerText = date;
        }
    }
    const getURLParameter = (name) => {
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue = urlParams.get(name);

        if (paramValue) {
            return paramValue.split(',');
        } else {
            return [];
        }
    }

    const checkRadioButtonsFromURL = (data) => {
        const radios = document.querySelectorAll('.eventslist__filter--categories input[type="radio"]');
        const urlParamValue = getURLParameter('categories')[0];

        radios.forEach(radio => {
            const filterName = radio.value;

            if (urlParamValue === filterName) {
                radio.checked = true;
                updateEventsList(data);
            }
        });
    };

    const setDateFromURL = (data) => {
        const filterDatePicker = document.getElementById('filterDateEventsList');
        const queryParams = new URLSearchParams(window.location.search);
        const dateParam = queryParams.get('date');
        if (filterDatePicker && dateParam) {
            filterDatePicker.value = dateParam;
            updateEventsList(data);
            updateSpanValue(dateParam);
        }
    };

    const filterButton = document.getElementById('filterBtnEventsList');
    filterButton.addEventListener('click', function () {
        var checkboxContainer = document.querySelector('.eventslist__filter--categories');
        checkboxContainer.style.display = checkboxContainer.style.display === 'block' ? 'none' : 'block';
    });

    const filterDatePicker = document.getElementById('filterDateEventsList');
    const getCurrentDate = new Date().toISOString().split('T')[0];
    filterDatePicker.min = getCurrentDate;
    filterDatePicker.value = getCurrentDate;
    updateSpanValue(getCurrentDate);
}

controller.add('eventscontainer', eventsContainer);


// WEBPACK FOOTER //
// ./Components/Pages/EventsContainer/eventscontainer.js